import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { MenuHighlights } from './components/MenuHighlights';
import { Atmosphere } from './components/Atmosphere';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-brand-black text-brand-offwhite selection:bg-brand-gold selection:text-brand-black" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <About data-id="element-4" />
        <MenuHighlights data-id="element-5" />
        <Atmosphere data-id="element-6" />
        <Contact data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}